import React from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Typography, Chip, CircularProgress, TablePagination } from "@mui/material";
import AnnouncementRowActions from "./AnnouncementRowActions";

const getStatusChipColor = (status) => {
  switch (status) {
    case "PUBLISHED":
      return "success";
    case "DRAFT":
      return "default";
    default:
      return "default";
  }
};

const AnnouncementsTable = ({
  announcements,
  totalCount,
  loading,
  selectedLang,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onPreview,
  onViewStats,
  onResetRecipients,
  onEdit,
  onDelete,
}) => {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 750 }}>
        <TableHead sx={{ bgcolor: "grey.200" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>Title ({selectedLang.toUpperCase()})</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Media Type</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Audience</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Published At</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Expires At</TableCell>
            <TableCell sx={{ fontWeight: 700 }} align="right">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : !announcements || announcements.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                <Typography color="text.secondary">No announcements found.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            announcements.map((row) => {
              const currentLangContent = row.content?.[selectedLang] || {};
              const title = currentLangContent.title || row.content?.en?.title || "Untitled";
              const hasCurrentLang = Boolean(currentLangContent.title);
              const mediaType = currentLangContent.mediaType || row.content?.en?.mediaType || "NONE";
              const isAll = row.otherContent?.allCompany !== false;
              const companyCount = row.otherContent?.companyIds?.length || 0;

              return (
                <TableRow key={row.id} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600}>
                      {title}
                    </Typography>
                    {selectedLang !== "en" && !hasCurrentLang && (
                      <Typography variant="caption" color="text.disabled" sx={{ fontStyle: "italic" }}>
                        (No {selectedLang.toUpperCase()} - Showing EN)
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip label={row.status} size="small" color={getStatusChipColor(row.status)} />
                  </TableCell>
                  <TableCell>
                    <Chip label={mediaType} size="small" variant="outlined" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {isAll ? "All Companies" : `${companyCount} ${companyCount === 1 ? "Company" : "Companies"}`}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">{row.publishedAt ? new Date(row.publishedAt).toLocaleDateString() : "Not set"}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">{row.expiresAt ? new Date(row.expiresAt).toLocaleDateString() : "Never"}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <AnnouncementRowActions announcement={row} onPreview={onPreview} onViewStats={onViewStats} onResetRecipients={onResetRecipients} onEdit={onEdit} onDelete={onDelete} />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={totalCount} page={page} onPageChange={onPageChange} rowsPerPage={rowsPerPage} onRowsPerPageChange={onRowsPerPageChange} />
    </TableContainer>
  );
};

export default AnnouncementsTable;
